import { render, staticRenderFns } from "./SettingsLeftMenuItem.vue?vue&type=template&id=4619447a&scoped=true&"
import script from "./SettingsLeftMenuItem.vue?vue&type=script&lang=js&"
export * from "./SettingsLeftMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./SettingsLeftMenuItem.vue?vue&type=style&index=0&id=4619447a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4619447a",
  null
  
)

export default component.exports